import _ from 'lodash';

const LessonProgressUtils = {
  // Given chunks and a chunkToReview, find the related self-mark chunk
  findSelfMarkChunk(chunkToReview, chunks) {
    let selfMarkChunk = null;
    if (chunkToReview.get('last_attempt')) {
      selfMarkChunk = chunks.find((chunk) => {
        const reviewedQuestionAttempt = chunk.getIn([
          'last_attempt',
          'reviewed_question_attempt',
        ]);
        return (
          reviewedQuestionAttempt &&
          reviewedQuestionAttempt ===
            chunkToReview.getIn(['last_attempt', 'id'])
        );
      });
    }

    if (_.isEmpty(selfMarkChunk)) {
      // There may be no question attempt so go by question_to_review
      selfMarkChunk = chunks.find(
        (chunk) =>
          chunk.getIn(['question', 'question_to_review']) ===
          chunkToReview.getIn(['question', 'id'])
      );
    }
    return selfMarkChunk;
  },
};

export default LessonProgressUtils;
